module.exports = __webpack_public_path__ + "img/video.031b345a.jpg";